"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // eslint-disable-next-line no-unused-vars


var View = function View(_ref) {
  var children = _ref.children;
  return children;
};

View.propTypes = {
  children: _propTypes["default"].node,
  viewId: _propTypes["default"].string.isRequired
};
var _default = View;
exports["default"] = _default;